/**
* In this file we handel the users Incoming calls with popup screen
**/
import { Modal,Button } from 'react-bootstrap';
import {useState,useEffect} from 'react';
import ApiService from './../../services/ApiService';
import Socket from './../../services/SocketService';
import {convertS3privateToPublic} from './../../services/UtilsService';
const { connect } = require('twilio-video');

function IncomingModal(props) {
	
//Intial state declaration
 const [room,setRoom]=useState({});
 const [video,setVideo] = useState(false);
 const [isHold,setHold] = useState(false);
 const [access,setAccess]=useState({initial:true,connect:false,end:false,isAudio:true,videoMute:true,audioMute:false});
  
  //Component initialize function
  useEffect(()=>{
	  //To check media device
	   navigator.mediaDevices?.enumerateDevices()
      .then((devices:any)=>{
        devices.forEach((device)=>{	
		    if(device.kind ==='videoinput'){
			   setVideo(true);
			}
		});
        });
		//To trigger the Hold call
       Socket.holdCall((data)=>{
		  holdCall(data);
	   });
	   
	// eslint-disable-next-line
  },[props.pop]);
  
  //To reject call
  const rejectCall=async()=>{

	  var response= await ApiService.rejectCall({roomName:props.data.room});
	  if(response.status===200){
		  props.handleClose(props.data.room);
		  //Socket.leaveCall(props.data.room);
	  }
	  
  };
  
  //To answer call
  const answerCall=async()=>{
	   setAccess(access => ({...access,initial:false,connect:true}));
	   var response= await ApiService.answerCall({roomName:props.data.room});
	   if(response.status===200){
		   Socket.joinCall(props.data.room);
		   setAccess(access => ({...access,end:true,connect:false,initial:false}));
		   connectRoom(response.data);   
	   }
  };
  
  /**  
  * To hold or unhold call 
  * @val we get the Boolean value 
  **/
  const holdCall=(val:any)=>{
    setHold(val);
	setRoom(prevRoom => {
     prevRoom.localParticipant.tracks.forEach((publications:any) => {
	     if(val===true){
		   publications.track.disable();
		 }else{
		    if(publications.kind==='video'){
			     access.videoMute?publications.track.disable():publications.track.enable();
			 }else if(publications.kind==='audio'){
			     access.audioMute?publications.track.disable():publications.track.enable();
			 }
		 }
	});
	 return prevRoom;
	});
  }
  
  /** 
  * To connect to call room
  * @data we get the Socket room name and twilio call token details
  **/
  const connectRoom=(data)=>{
	  
      connect(data.token, {name: data.room,video:video,audio:true }).then(room => { 
	       setRoom(room);
	      //To show the local user video in screen
		   room.localParticipant.tracks.forEach((publications) => {
		       if(publications.kind==='video'){
			     publications.track.disable()
			   }
			   var elmt=publications.track.attach();
			   var sender=document.getElementById('receiver_'+props.data.room);
		       sender.appendChild(elmt);
		   });
		   setAccess(access => ({ ...access,localAvator:true}));
		   room.participants.forEach(participantConnected);
		   room.on('participantConnected',participantConnected);
		   room.on('participantDisconnected', participantConnected);
			   
		   //It trigger when room disconnected
		   room.once('disconnected', (room)=>{
			   //Socket.leaveCall(room.name);
			   removeLocalParticipant(room);  
			   //setAccess({initial:false,connect:false,end:false,isAudio:true,videoMute:true,audioMute:false,completed:true});
			   setTimeout(()=>{
			     props.handleClose(props.data.room);	   
			   });
		   });
	  });
  };
  
  /**
  * To remove local participant form the room
  * @room pass the connected room call streams
  **/
  const removeLocalParticipant=(room)=>{
	 room.localParticipant.tracks.forEach((publication) => {
	   const attachedElements = publication.track.detach();			   
	   attachedElements.forEach((element) => element.remove());
	  });
  };
  
  /** 
  * This function used to Subscribed the participant audio and video streams
  * @participant we pass the participants streams details
  **/ 
  const participantConnected= (participant) => {
    var tracksDiv = document.getElementById('sender_'+props.data.room);
	if(participant.state==='disconnected'){
		setRoom(prevRoom => {
			prevRoom.disconnect();
			return prevRoom;
		});
	}else{
		setAccess(access => ({ ...access,remoteAvator:true}));
	}
	if(participant.videoTracks.size ===0){
		setAccess(access => ({ ...access, remoteAudio:true }));
	}
	participant.tracks.forEach((publication)  => {
		if (publication.isSubscribed) {
		  trackSubscribed(tracksDiv, publication.track);
		}
	  });
    participant.on('trackSubscribed', (track) => trackSubscribed(tracksDiv, track));
    participant.on('trackUnsubscribed',trackUnsubscribed);
  };
  
  /** 
  * To add participant to stream to UI popup design
  * @div we pass the HTML div element for popup creation
  * @track we pass the participant audio and video tracks
  **/ 
   const trackSubscribed = (div, track) => {
	  const trackElement = track.attach();
	  div.append(trackElement);
	  track.on('enabled', (enabled:any) => {
		if(enabled.kind==='video'){
			setAccess(access => ({ ...access,remoteAvator:false}));
		}
		});
	  track.on('disabled', (disable:any) => {
		if(disable.kind==='video'){
			setAccess(access => ({ ...access,remoteAvator:true}));
		}
	   });
   };
   
   //To close modal
   const closeModal=()=>{
	   if(Object.keys(room).length !==0){
		   endCall();
	   }else{
		   rejectCall();
	   }
   };
   
    /** 
	* This function used To remove participant 
	* @track we get the participant track details
	**/  
   const trackUnsubscribed = (track) => {
		  track.detach().forEach((element) => {
			element.remove()
		  })
    };
	
	/** To end call **/
	const endCall=()=>{
		room.disconnect();
	};
	
	/** To mute or Unmute video  **/
  const muteVideo=()=>{

     room.localParticipant.videoTracks.forEach((trackPublication:any) => {   
         !access.videoMute?trackPublication.track.disable():trackPublication.track.enable(); 
		 setAccess(access => ({ ...access,videoMute:!access.videoMute,localAvator:!access.localAvator}));
     });
  };
  
  /** To mute or Unmute voice  **/
  const muteVoice=()=>{
     room.localParticipant.audioTracks.forEach((trackPublication:any) => {
		 !access.audioMute?trackPublication.track.disable():trackPublication.track.enable(); 
		 setAccess(access => ({ ...access,audioMute:!access.audioMute}));
    })
  }

  return (
  <Modal 
	show={props.data.status}
	onHide={closeModal}  
	backdrop="static"
    keyboard={false}
	key={props.data.room}
	size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
      <Modal.Header closeButton>
        <Modal.Title>Incoming Call</Modal.Title>
      </Modal.Header>
      <Modal.Body>
			<div className="row text-center">
			{access?.isMissed&& <h4 className="text-danger">Call Missed</h4>}
			{access.initial && props?.data?.user?.fullName &&<h3>{props.data.user.fullName} is calling...</h3>}
				{/*Popup screen*/}
			    <div className={video?"col-6 position-relative":"col-6"} id={"receiver_"+props.data.room}>
				{access?.localAvator && video&& <img className="videoAvator rounded-circle w-50" src='/assets/img/user-avatar.png' alt='logo' />}
				{access.end && access.isAudio&& !video&& <div className="audioView"><img  className="rounded-circle w-50" src='/assets/img/user-avatar.png' alt='logo' /></div>}
				</div>
				<div className={access?.remoteAvator?"col-6 position-relative":"col-6"} id={"sender_"+props.data.room}>
				{access?.remoteAvator && <img className="videoAvator rounded-circle w-50" src={props?.data?.user?.photo==='default.png'?'/assets/img/user-avatar.png':convertS3privateToPublic(props?.data?.user?.photo)} alt='logo' />}
				{access?.remoteAudio && <div className="audioView"><img  className="rounded-circle w-50" src={props?.data?.user?.photo==='default.png'?'/assets/img/user-avatar.png':convertS3privateToPublic(props?.data?.user?.photo)} alt='logo' /></div>}
				</div>
			  <div className="col-xxl-12 text-center">
			  {access.initial && <i style={{cursor: 'pointer'}} onClick={answerCall} className="fas fa-phone text-success fa-1x"> Answer</i>}
			  {access.initial && <i style={{cursor: 'pointer'}} onClick={rejectCall} className="fas fa-phone text-danger fa-1x mx-2"> Reject</i>}
			  {access.connect && <h5>Connecting...</h5>}
			  {access.end &&<i onClick={endCall} className="fas fas fa-phone text-danger fa-2x mx-2" style={{cursor: 'pointer',transform: 'rotate(135deg)'}}></i>}
			  {access.end && <i onClick={muteVoice} className={access.audioMute?'fas fa-microphone-slash fa-2x mx-2':'fas fa-microphone fa-2x mx-2'}></i>}
              {access.end && <i onClick={muteVideo} className={access.videoMute?'fas fa-video-slash fa-2x mx-2':'fas fa-video fa-2x mx-2'}></i>}
			  {isHold && <i className="fas fa-pause-circle fa-2x">&nbsp;&nbsp;&nbsp;</i>}
              </div>
			</div>
			{/*End Popup screen*/}
	  </Modal.Body>
	  {/*Footer*/}
	  <Modal.Footer>
	   <Button variant="secondary" onClick={closeModal}>
          Close
        </Button>
        
	  </Modal.Footer>
	</Modal>
  );
}

export default IncomingModal;
